import type { LandingAssetsContent, LandingStepsContent } from "../types";

export const landingSteps: LandingStepsContent = {
  title: { lead: "Four steps. ", highlight: "No surprises." },
  ctaFullGuide: "See full How It Works",
  stepLabel: "STEP",
  steps: {
    chooseAccount: {
      title: "Choose your account",
      sub: "One-time fee. Five sizes. Two evaluation models.",
      body: "Pick from five funded tiers ($10K to $200K) and the evaluation model that fits your style. 1-Step is a single-phase path with tighter risk rules. 2-Step splits the evaluation into two more conservative phases. Pay once and start trading.",
      bullets: ["No subscription, no hidden fees", "Five sizes · two evaluation models"],
    },
    passEvaluation: {
      title: "Pass the evaluation",
      sub: "Reach the target. Respect the limits.",
      body: "Every rule is documented up front and applied consistently across both models. Reach the profit target while staying within the drawdown and risk-management limits. No time pressure.",
      bullets: [
        "No time limit on the evaluation",
        "Drawdown: 4% / 7% (1-Step) · 5% / 10% (2-Step)",
      ],
    },
    getFunded: {
      title: "Get funded",
      sub: "Live MT5. Institutional execution.",
      body: "Once you pass, you become eligible for a funded account on MetaTrader 5. Orders route directly to the market via STP execution, backed by institutional liquidity providers. The same infrastructure professional desks use.",
      bullets: ["MetaTrader 5", "STP execution · institutional liquidity"],
    },
    withdrawShare: {
      title: "Withdraw your share",
      sub: "80% base split. Regular payout windows.",
      body: "Funded traders submit payout requests on regular monthly windows. Every account starts on an 80% split. Higher splits unlock via the scaling plan or the optional split add-on at checkout.",
      bullets: ["80% base split · up to 90%", "Bank transfer or USDC / USDT"],
    },
  },
};

export const landingAssets: LandingAssetsContent = {
  title: { lead: "300+ instruments. ", highlight: "One account." },
  ctaFullList: "Full asset list",
  up: "▲ UP",
  down: "▼ DN",
  categories: {
    forex: { name: "Forex", countUnit: "pairs", description: "Maj / Min / Exotic" },
    indices: { name: "Indices", countUnit: "indices", description: "SPX, NDX, DAX" },
    metals: { name: "Metals", countUnit: "metals", description: "XAU, XAG, XPT" },
    crypto: { name: "Crypto", countUnit: "pairs", description: "BTC, ETH, SOL" },
    energies: { name: "Energies", countUnit: "energies", description: "WTI, BRENT, NG" },
  },
};
